/*
 * BB LP — behaviour for the landing-page sections.
 *
 * 1. <bb-lp-sticky>: mobile sticky CTA bar. Shows once the visitor scrolled past `data-show-after` pixels and
 *    the section referenced by `data-watch` (the quick-buy grid) is NOT in the viewport, so the bar never
 *    covers the real buy buttons.
 * 2. <bb-lp-video>: 9:16 social-proof video card. Tap toggles play/pause, only one video plays at a time.
 */

(() => {
  'use strict';

  if (!window.customElements.get('bb-lp-sticky')) {
    class BBLPSticky extends HTMLElement {
      connectedCallback() {
        this._showAfter = parseInt(this.dataset.showAfter || '500', 10);
        this._onScroll = this._update.bind(this);

        const anchor = document.getElementById(this.dataset.watch || '');
        // The anchor span sits at the top of the section; measure its parent section instead.
        this._target = anchor ? (anchor.closest('.shopify-section') || anchor) : null;

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
      }

      _targetVisible() {
        if (!this._target) return false;
        const rect = this._target.getBoundingClientRect();
        const vh = window.innerHeight;
        // Treat the quick-buy section as visible while a meaningful part of it is on screen.
        return rect.top < vh * 0.7 && rect.bottom > vh * 0.25;
      }

      _update() {
        const show = window.scrollY > this._showAfter && !this._targetVisible();
        this.classList.toggle('tw:translate-y-full', !show);
      }
    }

    window.customElements.define('bb-lp-sticky', BBLPSticky);
  }

  if (!window.customElements.get('bb-lp-video')) {
    class BBLPVideo extends HTMLElement {
      connectedCallback() {
        this._video = this.querySelector('video');
        this._toggle = this.querySelector('.bb-lp-video__toggle');
        if (!this._video) return;

        this.addEventListener('click', () => this._onClick());
        this._video.addEventListener('ended', () => this._setPlaying(false));
        this._video.addEventListener('pause', () => this._setPlaying(false));
        this._video.addEventListener('play', () => this._setPlaying(true));
      }

      _onClick() {
        if (this._video.paused) {
          document.querySelectorAll('bb-lp-video video').forEach((other) => {
            if (other !== this._video) other.pause();
          });
          this._video.play();
        } else {
          this._video.pause();
        }
      }

      _setPlaying(playing) {
        if (this._toggle) {
          this._toggle.classList.toggle('tw:opacity-0', playing);
        }
      }
    }

    window.customElements.define('bb-lp-video', BBLPVideo);
  }
})();
